/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import * as Styled from "./styles";
import { useMetrus } from "shared/providers";

import { Controller, useForm } from "react-hook-form";
import { IForm, ILabelValue } from "shared/types";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { Card } from "components/Card";
import { Paginate } from "components/Pagination";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import toast from "react-hot-toast";
import AutoComplete from "components/Autocomplete";

import { FaAngleDoubleDown, FaAngleDoubleUp } from "react-icons/fa";

const quaLegends = [
  { title: "Programa de Acreditação", icon: "a" },
  { title: "Doutorado / Pós Doutorado", icon: "d" },
  { title: "Título de Especialista", icon: "e" },
  {
    title:
      "Certificações de Entidades Gestoras de Outros Programas de Qualidade",
    icon: "g",
  },
  {
    title: "Certificação ISO 9001",
    icon: "i",
  },
  {
    title: "Mestrado",
    icon: "m",
  },
  {
    title: "Comunicação de Eventos Adversos",
    icon: "n",
  },
  {
    title: "Pós Graduação - Lato Sensu",
    icon: "p",
  },
  {
    title: "Qualidade Monitorada",
    icon: "q",
  },
  {
    title: "Residência",
    icon: "r",
  },
];

const FormHome: React.FC = () => {
  const {
    step,
    setStep,
    setList,
    insuranceIdNext,
    setInsuranceIdNext,
    setProviderId,
    providerId,
    specialistId,
    setSpecialistId,
    loading,
    setLoading,
    service,
    page,
    setPage,
    totalPages,
    disabledCity,
    setDisabledCity,
    specialistSelect,
    typeSelect,
    setCityId,
    cityId,
    regionName,
    setRegionName,
    neighID,
    setNeighId,
    state,
    setState,
    nameProviderId,
    setNameProviderId,
    states,
    cities,
    neighborhood,
    emergency,
    setEmergency,
    setDisabledRegion,
    disabledNeigh,
    setDisabledNeigh,
    setDisabledStreet,
    disabledName,
    nameProvider,
    region,
    latGoogle,
    longGoogle,
    preferr,
    setPreferr,
    setLatGoogle,
    setLongGoogle,
    setFilters,
    filters,
  } = useMetrus();

  const [regionItem, setRegionItem] = React.useState<ILabelValue>(
    {} as ILabelValue,
  );

  const [isImpression, setIsImpression] = React.useState<boolean>(false);

  const { handleSubmit, control, reset, setValue } = useForm<IForm>({
    mode: "onBlur",
    reValidateMode: "onChange",
  });

  const onSubmit = async () => {
    setLoading(true);
    setFilters({
      ...filters,
      insurance: insuranceIdNext,
      provider: nameProviderId,
      address: "",
      page: page,
      quantity: 25,
      specialist: specialistId,
      typeProvider: providerId,
      emergency: emergency,
      state: state,
      city: cityId,
      region: regionName,
      neighbordhood: neighID,
      lat: latGoogle,
      long: longGoogle,
    });
  };

  const onPrevius = () => {
    setStep(step - 1);
    setDisabledCity(true);
    setDisabledNeigh(true);
    setDisabledRegion(true);
    setDisabledStreet(true);
    if (step === 2) {
      setInsuranceIdNext(0);
      setPreferr("NOT_DEFINED");
    }

    if (step === 3) {
      setState("");
      setCityId("");
      setNeighId("");
      setProviderId("");
      setSpecialistId("");
      setNameProviderId("");
    }

    if (step === 4) {
      setSpecialistId("");
      setNameProviderId("");
      setProviderId("");
      setPage(1);
    }
  };

  const onNext = () => {
    if (!insuranceIdNext) {
      toast.error("Escolha um plano para seguir");
      return false;
    }

    if (step !== 4) {
      setStep(step + 1);
    } else {
      setList(true);
    }
  };

  const next = React.useCallback(async () => {
    setLoading(true);
    setFilters({
      ...filters,
      insurance: insuranceIdNext,
      provider: nameProviderId,
      address: "",
      page: page,
      quantity: 25,
      specialist: specialistId,
      typeProvider: providerId,
      emergency: emergency,
      state: state,
      city: cityId,
      region: regionName,
      neighbordhood: neighID,
      lat: latGoogle,
      long: longGoogle,
    });
  }, [page]);

  const nextPage = () => {
    setPage(page + 1);
    window.scrollTo(0, 0);
  };

  const prevPage = () => {
    setPage(page - 1);
    window.scrollTo(0, 0);
  };

  function firstPage() {
    setPage(1);
  }

  function lastPage() {
    setPage(totalPages);
  }

  function scrollToBottom(): void {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  }

  function scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  function printContent(): void {
    const scrollElement = document.querySelector(".scroll");
    setIsImpression(true);

    if (scrollElement) {
      document.body.classList.add("print-active");

      setTimeout(() => {
        window.print();
        setIsImpression(false);
        document.body.classList.remove("print-active");
      }, 0);
    } else {
      console.error('Elemento com a classe "scroll" não encontrado.');
    }
  }
  React.useEffect(() => {
    next();
  }, [next]);

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "50px",
          }}
        >
          <CircularProgress size={40} />
        </div>
      ) : (
        <Styled.Container onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <>
            {step === 2 && (
              <>
                <AutoComplete
                  onChange={() => {
                    setValue("city.label", "");
                    setValue("city.value", "");
                    setValue("state.label", "");
                    setValue("state.value", "");
                    setValue("region.label", "");
                    setValue("region.value", "");
                    setValue("neighborhood.label", "");
                    setValue("neighborhood.value", "");
                  }}
                />{" "}
                <Divider>ou</Divider>
              </>
            )}
            <Styled.Form isFirst={step === 1}>
              {step === 2 && (
                <>
                  <></>
                  <>
                    {
                      <Controller
                        control={control}
                        name="state"
                        render={({ field: { ref, onChange, ...field } }) => (
                          <Autocomplete
                            disableClearable
                            options={states}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) =>
                              option.value === value.value
                            }
                            autoComplete={false}
                            onChange={(_, options) => {
                              onChange(options);
                              setState(options?.value as string);
                              reset();
                              setPreferr("SELECT");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                {...field}
                                inputRef={ref}
                                label="Escolha o seu estado"
                              />
                            )}
                          />
                        )}
                      />
                    }

                    {
                      <Controller
                        control={control}
                        name="city"
                        render={({ field: { ref, onChange, ...field } }) => (
                          <Autocomplete
                            options={cities}
                            disableClearable
                            disabled={disabledCity}
                            autoComplete={false}
                            onChange={(_, options) => {
                              onChange(options);
                              setCityId(options?.value as string);
                              setDisabledNeigh(false);
                              setDisabledStreet(true);
                              setDisabledRegion(true);
                              setProviderId("");
                              setNameProviderId("");
                              setSpecialistId("");
                              setRegionName("");
                              setNeighId("");
                              setValue("neighborhood.label", "");
                              setValue("neighborhood.value", "");
                              setPreferr("SELECT");
                              setLatGoogle(0);
                              setLongGoogle(0);

                              if (options.label !== "São Paulo") {
                                setRegionItem(region[0]);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                {...field}
                                inputRef={ref}
                                label="Escolha a sua cidade"
                              />
                            )}
                          />
                        )}
                      />
                    }

                    {
                      <Controller
                        control={control}
                        name="region"
                        defaultValue={
                          regionItem &&
                          regionItem.label &&
                          regionItem.label.length > 1
                            ? regionItem
                            : region[0]
                        }
                        render={({ field: { ref, onChange, ...field } }) => (
                          <Autocomplete
                            options={region}
                            disableClearable
                            autoComplete={false}
                            disabled={cityId === "São Paulo" ? false : true}
                            value={
                              regionItem &&
                              regionItem.label &&
                              regionItem.label.length > 1
                                ? regionItem
                                : region[0]
                            }
                            onChange={(_, options) => {
                              onChange(options);
                              setRegionName(options?.value as string);
                              setDisabledStreet(true);
                              setValue("neighborhood.label", "");
                              setValue("neighborhood.value", "");
                              setProviderId("");
                              setSpecialistId("");
                              setRegionItem(options);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                {...field}
                                inputRef={ref}
                                label="Escolha a sua região"
                              />
                            )}
                          />
                        )}
                      />
                    }

                    {
                      <Controller
                        control={control}
                        name="neighborhood"
                        render={({ field: { ref, onChange, ...field } }) => (
                          <Autocomplete
                            //multiple
                            options={neighborhood}
                            disableClearable
                            disabled={disabledNeigh}
                            onChange={(_, options) => {
                              onChange(options);
                              setNeighId(options?.value as string);
                              setDisabledStreet(false);
                              setValue("street.label", "");
                              setValue("street.value", "");
                              setProviderId("");
                              setSpecialistId("");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                {...field}
                                inputRef={ref}
                                label="Escolha o seu bairro"
                              />
                            )}
                          />
                        )}
                      />
                    }

                    {/*<Controller
                      control={control}
                      name="street"
                      render={({ field: { ref, onChange, ...field } }) => (
                        <Autocomplete
                          //multiple
                          options={street}
                          disableClearable
                          disabled={disabledStreet}
                          onChange={(_, options) => {
                            onChange(options);
                            setStreetId(options?.value as string);
                            setStreetName(options?.label as string);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              {...field}
                              inputRef={ref}
                              label="Escolha o logradouro"
                            />
                          )}
                        />
                      )}
                    />*/}
                  </>
                </>
              )}
              {step === 3 && (
                <>
                  <Controller
                    control={control}
                    name="provider"
                    render={({ field: { ref, onChange, ...field } }) => (
                      <Autocomplete
                        disableClearable
                        options={typeSelect}
                        onChange={(_, options) => {
                          onChange(options);
                          setProviderId(options?.label as string);
                          setValue("specialist.label", "");
                          setValue("specialist.value", "");
                          setValue("name.label", "");
                          setValue("name.value", "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            {...field}
                            inputRef={ref}
                            label="Tipo de Prestador de Saúde"
                          />
                        )}
                      />
                    )}
                  />

                  <Controller
                    control={control}
                    name="specialist"
                    render={({ field: { ref, onChange, ...field } }) => (
                      <Autocomplete
                        disableClearable
                        disabled={specialistSelect.length < 1}
                        options={specialistSelect}
                        onChange={(_, options) => {
                          onChange(options);
                          setSpecialistId(options?.label as string);
                          setValue("name.label", "");
                          setValue("name.value", "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            {...field}
                            inputRef={ref}
                            label="Especialidade"
                          />
                        )}
                      />
                    )}
                  />

                  <Controller
                    control={control}
                    name="name"
                    render={({ field: { ref, onChange, ...field } }) => (
                      <Autocomplete
                        disableClearable
                        options={nameProvider}
                        disabled={disabledName}
                        onChange={(_, options) => {
                          onChange(options);
                          setNameProviderId(options?.label as string);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            {...field}
                            inputRef={ref}
                            label="Prestador"
                          />
                        )}
                      />
                    )}
                  />

                  <FormControlLabel
                    control={
                      <Controller
                        name="urgency"
                        control={control}
                        render={({ field: props }) => (
                          <Checkbox
                            {...props}
                            checked={props.value}
                            onClick={() => setEmergency(!emergency)}
                            onChange={(e: any) =>
                              props.onChange(e.target.checked)
                            }
                          />
                        )}
                      />
                    }
                    label="Atende Urgência/Emergência"
                  />
                </>
              )}
            </Styled.Form>
            {step === 4 && (
              <Styled.List>
                {(service ?? []).length > 0 ? (
                  <>
                    <Styled.BoxTop>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "end",
                          gap: "10px",
                          paddingRight: "20px",
                          paddingBottom: "22px",
                        }}
                      >
                        <Button
                          onClick={onPrevius}
                          startIcon={<IoIosArrowBack />}
                        >
                          Voltar
                        </Button>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "end",
                          gap: "10px",
                          paddingRight: "20px",
                          paddingBottom: "22px",
                        }}
                      >
                        <Button onClick={printContent}>Imprimir</Button>
                        <Button onClick={scrollToBottom}>
                          <FaAngleDoubleDown size={20} />
                        </Button>
                      </Box>
                    </Styled.BoxTop>

                    <Styled.SortBar>
                      <Styled.SortLabel>Ordenar por:</Styled.SortLabel>
                      <Styled.SortButton
                        active={false}
                        onClick={() =>
                          setFilters({
                            ...filters,
                            sortAlpha: filters.sortAlpha === "az" ? "za" : "az",
                          })
                        }
                        type="button"
                      >
                        {filters.sortAlpha === "az" ? "A-Z" : "Z-A"}
                      </Styled.SortButton>
                      <Styled.NetworkButton
                        active={filters.networkFilter === "1"}
                        type="button"
                        onClick={() =>
                          setFilters({
                            ...filters,
                            networkFilter:
                              filters.networkFilter === "1" ? "0" : "1",
                          })
                        }
                      >
                        <img
                          src="rede_referenciada_icon.svg"
                          alt=""
                          width={16}
                          height={16}
                        />
                        Rede Referenciada
                      </Styled.NetworkButton>
                    </Styled.SortBar>

                    <Styled.Scroll className="scroll">
                      {service.map((item, index) => (
                        <Card
                          data={item}
                          key={index}
                          impression={isImpression}
                        />
                      ))}
                    </Styled.Scroll>
                    <Box sx={{ textAlign: "right" }}>
                      <Button onClick={scrollToTop}>
                        <FaAngleDoubleUp size={20} />
                      </Button>
                    </Box>
                    <Styled.QuaLegend>
                      <Styled.LegendTitle>Legenda de Ícones</Styled.LegendTitle>
                      {quaLegends.map((leg, index) => (
                        <Styled.QuaLegendItem key={`leg${index}`}>
                          <Styled.QuaLegendImg>
                            <img
                              src={`quali_icones/${leg.icon.toUpperCase()}.png`}
                              alt={leg.title}
                            />
                          </Styled.QuaLegendImg>
                          <Styled.QuaLegendTitle>
                            {leg.title}
                          </Styled.QuaLegendTitle>
                        </Styled.QuaLegendItem>
                      ))}
                    </Styled.QuaLegend>
                    <Styled.Center>
                      <Paginate
                        onNextPage={nextPage}
                        onPrevPage={prevPage}
                        pageNow={page}
                        totalPages={totalPages}
                        onFirstPage={firstPage}
                        onLastPage={lastPage}
                      />
                    </Styled.Center>
                  </>
                ) : (
                  <Alert severity="info" sx={{ width: "100%" }}>
                    Nenhum prestador encontrado.
                  </Alert>
                )}
                <Styled.Btns>
                  <Button variant="contained" onClick={onPrevius}>
                    Voltar
                  </Button>
                </Styled.Btns>
              </Styled.List>
            )}
            {preferr !== "NOT_DEFINED" && (
              <Styled.Btns disabled={step === 4 || step === 1}>
                <Button
                  disabled={step === 2}
                  onClick={onPrevius}
                  startIcon={<IoIosArrowBack />}
                >
                  Voltar
                </Button>

                {step === 4 ? (
                  <Button
                    onClick={onNext}
                    type={"submit"}
                    endIcon={<IoIosArrowForward />}
                  >
                    Continuar
                  </Button>
                ) : (
                  <Button
                    onClick={onNext}
                    type={"button"}
                    endIcon={<IoIosArrowForward />}
                  >
                    Continuar
                  </Button>
                )}
              </Styled.Btns>
            )}
          </>
        </Styled.Container>
      )}
    </>
  );
};

export { FormHome };
